import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    styled,
} from "@mui/material"
import { ReactElement, ReactNode } from "react"

interface IAppAccordionSummaryProps {
    children: ReactNode
}

/**
 * Wrapper for MUI AccordionSummary component. This component
 * is used to wrap the content of an accordion. It is used to
 * apply a consistent style to the content of all accordions
 * in the application.
 */
const AppAccordionSummary = ({
    children,
}: IAppAccordionSummaryProps): ReactElement => (
    <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={(theme) => ({
            backgroundColor:
                theme.palette.mode === "dark"
                    ? theme.palette.background.contentBackground
                    : theme.palette.primary.light,
        })}
    >
        {children}
    </AccordionSummary>
)

/**
 * Styled MUI Accordion component.
 */
const AppAccordion = styled(Accordion)({
    boxShadow: "none",
})

const AppAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
}))

export { AppAccordionSummary, AppAccordion, AppAccordionDetails }
